import Vorschaltseite from './0_vorschaltseite';
import Prepage from './0a_prepage';
import ErsteDaten from './1_erstedaten';
import Produktvergleich from './2_produktvergleich';
import Personendaten from './3_personendaten';
import Vorversicherung from './4_vorversicherung';
import Zahlungsdaten from './5_zahlungsdaten';
import Zusammenfassung from './6_zusammenfassung';
import Beantragen from './7_beantragen';
import Abschluss from './8_abschluss';
import AngabenGespraech from './9_euBeratung/1_angabenGespraech';
import EmpfehlungBerater from './9_euBeratung/2_empfehlungBerater';
import Druckmatrix from './10_druckmatrix';
import Unterschrift from './11_unterschrift';

export default {
  Vorschaltseite,
  Prepage,
  ErsteDaten,
  Produktvergleich,
  Personendaten,
  Vorversicherung,
  Zahlungsdaten,
  Zusammenfassung,
  Beantragen,
  Abschluss,
  AngabenGespraech,
  EmpfehlungBerater,
  Druckmatrix,
  Unterschrift,
};
